import { SecurityHelper } from 'sarsaparilla';
import axios from 'axios';
import * as types from '../constants';

export const loginSucceeded = (profile) => ({
    type: types.LOGIN_SUCCESS,
    profile
});

export const updateFailed = () => ({
    type: types.ACCOUNT_UPDATE_FAILED
});

export const emailSent = () => ({
    type: types.UPDATE_EMAIL_SENT
});

export const profileUpdated = () => ({
    type: types.ACCOUNT_UPDATED
});

export const updateAccount = (acct) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/account`;
            const response = await axios.put(url, acct, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
            const profile = response.data;
            if ('success' in response.data) {
                dispatch(emailSent());
            }
            else {
                window.localStorage.setItem('recaccount', JSON.stringify(profile));
                dispatch(loginSucceeded(profile));
                dispatch(profileUpdated());
            }
        }
        catch (error) {
            dispatch(updateFailed());
            throw error;
        }
    };
};

export const updatePasses = (acct) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/account/passes`;
            const response = await axios.put(url, acct, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
            const profile = response.data;
            if ('success' in response.data) {
                dispatch(emailSent());
            }
            else {
                window.localStorage.setItem('recaccount', JSON.stringify(profile));
                dispatch(loginSucceeded(profile));
                dispatch(profileUpdated());
            }
        }
        catch (error) {
            dispatch(updateFailed());
            throw error;
        }
    };
};

export const validateToken = (token) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/account/${token}`;
            const response = await axios.post(url, {}, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
            const profile = response.data;
            window.localStorage.setItem('recaccount', JSON.stringify(profile));
            dispatch(loginSucceeded(profile));
            dispatch(profileUpdated());
        }
        catch (error) {
            dispatch(updateFailed());
        }
    };
};

export const validateAuthToken = (token) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/validate`;
            const body = { token };
            const response = await axios.post(url, body);
            const profile = response.data;
            window.localStorage.setItem('recaccount', JSON.stringify(profile));
            dispatch(loginSucceeded(profile));
            dispatch(profileUpdated());
        }
        catch (error) {
            dispatch(updateFailed());
        }
    };
};


export const resetProfileMessages = () => {
    return (dispatch) => {
        dispatch({
            type: types.RESET_PROFILE_MESSAGE_FLAGS
        });
    };
};

export const showReviewSuccessRibbon = (show) => {
    return (dispatch) => {
        dispatch({
            type: show !== false ? types.SHOW_REVIEW_SUCCESS_RIBBON : types.HIDE_REVIEW_SUCCESS_RIBBON
        });
    };
};

export const getAccountRatings = () => {
    return async (dispatch) => {
        try {
            const accountId = SecurityHelper.getAccount().account_id;
            if (!accountId) {
                return;
            }
            const url = `${process.env.API}/ratingreview/ratings/account/${accountId}`;

            const response = await axios.get(url, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
            const reviews = response.data.ratings;
            const reviewsById = {};
            reviews.map((review) => reviewsById[review.reservation_id] = review);
            dispatch({
                type: types.FETCH_ACCOUNT_RATINGS_SUCCESS,
                data: reviewsById
            });
        }
        catch (error) {
            dispatch({
                type: types.FETCH_ACCOUNT_RATINGS_FAILED
            });
        }
    };
};

export const validateGuestToken = (profile) => {
    return (dispatch) => {
        try {
            window.localStorage.setItem('recaccount', JSON.stringify(profile));
            dispatch(loginSucceeded(profile));
            dispatch(profileUpdated());
        }
        catch (e) {
            dispatch(updateFailed());
        }
    };
};
